/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import CampaignModel from 'cio/models/campaign';
import VisualWorkflowBuilderService from 'cio/services/visual-workflow-builder';
import AnalyticsService from 'cio/services/analytics';
import { VWBTab } from 'cio/utils/visual-workflow-builder/types';
import { Periods } from 'cio/utils/metrics/common';
import { TimeRange } from 'cio/utils/time';

interface VisualWorkflowBuilderAddActionsPanelTabsArgs {
  isSaving: boolean;
  tab: VWBTab;
  changeTab: (tab: VWBTab) => unknown;
  campaign: CampaignModel;
  metricsTabSelectedMeasures: string[];
  metricsTabTimePeriod: Periods;
  metricsTabTimeRange: TimeRange;
}

export default class VisualWorkflowBuilderAddActionsPanelTabs extends Component<VisualWorkflowBuilderAddActionsPanelTabsArgs> {
  @service analytics!: AnalyticsService;
  @service visualWorkflowBuilder!: VisualWorkflowBuilderService;

  @action
  changeTab(tab: VWBTab) {
    this.args.changeTab(tab);
    this.visualWorkflowBuilder.redrawConnectingLines();
    this.analytics.track('campaign', 'workflow_tray_tab_changed', {
      model: this.args.campaign,
      trayTab: tab,
      timePeriod: this.args.metricsTabTimePeriod,
      timeRange: this.args.metricsTabTimeRange,
      selectedMetrics: this.args.metricsTabSelectedMeasures,
    });
  }
}
